<div class="p-grid">
    <div class="p-col-12 page-header">Reports</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="card">
        <div class="ui-g">
            <div class="ui-g-12">
                <p-table [value]="reports"
                         dataKey="Id"
                         [paginator]="false"
                         [responsive]="true"
                         [resizableColumns]="true">
                    <ng-template pTemplate="body" let-rowData>
                        <tr [pRowToggler]="rowData" [pSelectableRow]="rowData">
                            <td *ngFor="let col of cols" [ngStyle]="{'display': col.display, 'width' : col.width}" class="ui-resizable-column">{{rowData[col.field]}} </td>
                            <td class="ui-resizable-column" style="width: 10em">
                                <div *ngIf="showGetReport(rowData)">
                                    <button pButton label="Get Report" class="save-btn" (click)="this[rowData['ClickFunction']]()"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
    
<p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [header]="dialogHeader" [(visible)]="displayDialog"
        [responsive]="true" showEffect="fade" (onHide)="onHideReportDialog($event)">
<div class="">
    <div class="ui-g ui-fluid">

        <div class="ui-g-12">
            <div class="ui-g-3">Export Format</div>
            <div class="ui-g-6">
                <p-dropdown [showClear]="true" appendTo="body"
                            [options]="reportFormatOptions"
                            placeholder="Select One"
                            [(ngModel)]="reportFormat">
                </p-dropdown>
            </div>
        </div>

        <div class="ui-g-12" *ngFor="let parameter of currentReportParameters;">

            <div class="ui-g-3">{{parameter.label}}: </div>
            <div class="ui-g-6">

                <ng-container [ngSwitch]="parameter.controlType">

                    <ng-container *ngSwitchCase="'textbox'">
                        <input pInputText *ngIf="parameter.inputType == 'text';else elseDate" [name]="parameter.key" [id]="parameter.key" [type]="parameter.inputType" [(ngModel)]="parameter.value" />

                        <ng-template #elseDate>
                            <p-calendar (onInput)="MaskDate($event)" appendTo="body" name="{{parameter.key}}" id="{{parameter.key}}" placeholder="mm/dd/yyyy" dataType="string" [showIcon]="true" [(ngModel)]="parameter.value"></p-calendar>
                        </ng-template>

                    </ng-container>

                    <ng-container *ngSwitchCase="'radio'">
                        <input id="{{parameter.key}}" [value]='parameter.value' type="radio" name="radio_bttons">
                    </ng-container>

                    <ng-container *ngSwitchCase="'select'">

                        <p-multiSelect *ngIf="parameter.multiple;else notMultiple"
                                        appendTo="body"
                                        [options]="parameter.options"
                                        [filter]="true"
                                        placeholder="Select One"
                                        name="{{parameter.key}}"
                                        id="{{parameter.key}}"
                                        [(ngModel)]="parameter.value">
                        </p-multiSelect>

                        <ng-template #notMultiple>

                            <p-dropdown [showClear]="true" appendTo="body"
                                        [options]="parameter.options"
                                        placeholder="Select One"
                                        name="{{parameter.key}}"
                                        id="{{parameter.key}}"
                                        [(ngModel)]="parameter.value">
                            </p-dropdown>

                        </ng-template>
                    </ng-container>



                </ng-container>
            </div>
        </div>
    </div>
</div>
<p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <button pButton label="Download Report" icon="ui-icon-check" (click)="GetReport()"></button>
    </div>
</p-footer>
</p-dialog>

